import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Button,
  Checkbox,
  Typography,
  Grid,
} from '@material-ui/core';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import queryString from 'query-string';
import React, { useContext, useEffect, useState } from 'react';
// import { useHistory } from 'react-router-dom';

import Header from 'components/Header';
import FeaturedResource from 'components/FeaturedResource';
import ResourceCard from 'components/ResourceCard';

import { ctx, IStore } from '../../store';

import { useStyles } from './styles';

const Library: React.FC = () => {
  const classes = useStyles();
  const [expanded, setExpanded] = useState<string | false>(false);
  const [selectedSkills, setSelectedSkills] = useState<string[]>([]);
  const [selectedCategories, setSelectedCategories] = useState<string[]>([]);
  const [selectedLanguage, setSelectedLanguage] = useState<string>('');

  const {
    resources: { featuredResources, resources, skills },
  } = useContext(ctx.store);
  const actions = useContext(ctx.actions);

  useEffect(() => {
    const fetch = async () => {
      await ((actions.resources.getSkills() as unknown) as Promise<IStore>);
    };

    if (!skills.length) {
      fetch();
    }
  }, []);

  useEffect(() => {
    if (skills.length && !resources.length) {
      actions.resources.getResources();
    }
  }, [skills]);

  const handleChange = (panel: string) => (
    _: React.ChangeEvent<unknown | HTMLInputElement>,
    isExpanded: boolean
  ) => {
    setExpanded(isExpanded ? panel : false);
  };

  const onChangeSkills = (skill: string) => {
    const currentList = [...selectedSkills];
    const exist = currentList.find((element: string) => element === skill);
    if (exist) {
      const newList = currentList.filter((element: string) => element !== skill);
      setSelectedSkills(newList);
    } else {
      const newList = [...selectedSkills];
      newList.push(skill);
      setSelectedSkills(newList);
    }
  };

  const onChangeCategories = (category: string) => {
    const currentList = [...selectedCategories];
    const exist = currentList.find((element: string) => element === category);
    if (exist) {
      const newList = currentList.filter((element: string) => element !== category);
      setSelectedCategories(newList);
    } else {
      const newList = [...selectedCategories];
      newList.push(category);
      setSelectedCategories(newList);
    }
  };

  const onChangeLanguage = (value: string) => {
    if (selectedLanguage === value) {
      setSelectedLanguage('');
    } else {
      setSelectedLanguage(value);
    }
  };

  const onFilter = async () => {
    if (selectedSkills.length || selectedCategories.length || selectedLanguage) {
      const query = queryString.stringify({
        ['skills.name']: selectedSkills,
        category: selectedCategories,
        language: selectedLanguage,
      });
      await ((actions.resources.getResources(query) as unknown) as Promise<IStore>);
    } else {
      await ((actions.resources.getResources() as unknown) as Promise<IStore>);
    }
  };

  return (
    <Grid container className={classes.root}>
      <Header />
      <FeaturedResource resources={featuredResources} />
      <Grid container spacing={3} style={{ justifyContent: 'center' }}>
        <Grid item xs={12} sm={12} md={3} lg={3} className={classes.filterPanel}>
          {skills.length && (
            <Grid className={classes.filtersWrapper}>
              {[{ name: 'post' }, { name: 'video' }, { name: 'podcast' }, { name: 'course' }]
                .length > 1 && (
                <Accordion
                  expanded={expanded === 'panel-category'}
                  onChange={handleChange('panel-category')}
                  className={classes.accordion}
                  style={{ marginTop: '50px' }}
                >
                  <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-label="panel-category-header"
                    id="panel-category-header"
                    style={{ boxShadow: 'none' }}
                  >
                    <Typography className={classes.panelTitle}>Categories</Typography>
                  </AccordionSummary>
                  <AccordionDetails>
                    <Grid container>
                      {[
                        { name: 'post' },
                        { name: 'video' },
                        { name: 'podcast' },
                        { name: 'course' },
                      ].map((element: any, i: number) => {
                        const selected = selectedCategories.find(
                          (category: string) => category === element.name
                        );
                        return (
                          <Grid key={i} item xs={12}>
                            <Grid
                              container
                              spacing={1}
                              justify="center"
                              direction="row"
                              alignContent="center"
                              alignItems="center"
                            >
                              <Grid item xs={3}>
                                <Checkbox
                                  color="primary"
                                  checked={!!selected}
                                  onChange={() => onChangeCategories(element.name)}
                                  inputProps={{
                                    'aria-label': `course-result-component-checkbox-category-${element.name}`,
                                  }}
                                />
                              </Grid>
                              <Grid item xs={9}>
                                <Typography>{element.name}</Typography>
                              </Grid>
                            </Grid>
                          </Grid>
                        );
                      })}
                    </Grid>
                  </AccordionDetails>
                </Accordion>
              )}
              {skills.length > 1 && (
                <Accordion
                  expanded={expanded === 'panel-tags'}
                  onChange={handleChange('panel-tags')}
                  className={classes.accordion}
                >
                  <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-label="panel-tags-header"
                    id="panel-tag-header"
                    style={{ boxShadow: 'none' }}
                  >
                    <Typography className={classes.panelTitle}>Skills</Typography>
                  </AccordionSummary>
                  <AccordionDetails>
                    <Grid container>
                      {skills.map((element: any, i: number) => {
                        const selected = selectedSkills.find(
                          (skills: string) => skills === element.name
                        );
                        return (
                          <Grid key={i} item xs={12}>
                            <Grid
                              container
                              spacing={1}
                              justify="center"
                              direction="row"
                              alignContent="center"
                              alignItems="center"
                            >
                              <Grid item xs={3}>
                                <Checkbox
                                  color="primary"
                                  checked={!!selected}
                                  onChange={() => onChangeSkills(element.name)}
                                  inputProps={{
                                    'aria-label': `course-result-component-checkbox-skill-${element.name}`,
                                  }}
                                />
                              </Grid>
                              <Grid item xs={9}>
                                <Typography>{element.name}</Typography>
                              </Grid>
                            </Grid>
                          </Grid>
                        );
                      })}
                    </Grid>
                  </AccordionDetails>
                </Accordion>
              )}

              <Accordion
                expanded={expanded === 'panel-for-kids'}
                onChange={handleChange('panel-for-kids')}
                className={classes.accordion}
              >
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-label="panel-for-kids-header"
                  id="panel-for-kids-header"
                  style={{ boxShadow: 'none' }}
                >
                  <Typography className={classes.panelTitle}>Language</Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <Grid container>
                    {['english', 'spanish'].map((element: any, i: number) => {
                      return (
                        <Grid item xs={4} key={i}>
                          <Grid
                            container
                            justify="center"
                            direction="row"
                            alignContent="center"
                            alignItems="center"
                          >
                            <Grid item xs={5}>
                              <Checkbox
                                color="primary"
                                checked={selectedLanguage === element}
                                onChange={() => onChangeLanguage(element)}
                                inputProps={{
                                  'aria-label': `course-result-checkbox-kids-${element}`,
                                }}
                              />
                            </Grid>
                            <Grid item xs={6}>
                              <Typography>{String(element)}</Typography>
                            </Grid>
                          </Grid>
                        </Grid>
                      );
                    })}
                  </Grid>
                </AccordionDetails>
              </Accordion>
              <Button
                variant="contained"
                color="primary"
                className={classes.applyFilters}
                type="button"
                onClick={onFilter}
              >
                Apply
              </Button>
            </Grid>
          )}
        </Grid>
        <Grid container xs={9} className={classes.postGrids}>
          {resources.map((resource: any, index: number) => (
            <ResourceCard key={index} resource={resource} />
          ))}
        </Grid>
      </Grid>
    </Grid>
  );
};

export { Library };
